module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-backward-circle-fill-dd1d6cb5.svg";